const staffStaffManagement = () =>
  import('@/views/main/staff/staff-management/staff-management.vue')
export default {
  path: '/main/staff/staffManagement',
  name: 'staffStaffManagement',
  component: staffStaffManagement,
  children: []
}
